import { sortBy } from 'es-toolkit'
import { useState, useMemo } from 'react'

import type { RoleType, UserHasTenantManagedWorkspace } from 'api/users/types'

export type EditAuthorizationProps = {
  role: RoleType
  canViewBOP: boolean
  canManageBOP: boolean
}

export type EditPermissionProps = {
  role: RoleType
  canViewBOP: boolean
  canManageBOP: boolean
  managedWorkspaces: UserHasTenantManagedWorkspace[]
}

const useUser = () => {
  const [editPermissionData, setEditPermissionData] = useState<EditPermissionProps | undefined>()

  const disabled = useMemo(() => !editPermissionData, [editPermissionData])

  const managedWorkspaceCheckBoxItems = useMemo(() => {
    if (!editPermissionData?.managedWorkspaces) {
      return []
    }
    return sortBy(editPermissionData.managedWorkspaces, ['name']).map(workspace => ({
      id: workspace.id,
      label: workspace.name,
      checked: workspace.isManagement,
    }))
  }, [editPermissionData?.managedWorkspaces])

  const bopManagementChangeBoxItems = useMemo(() => {
    if (!editPermissionData) {
      return []
    }

    return [
      {
        id: 'bopView',
        label: '収支閲覧',
        checked: editPermissionData.canViewBOP,
      },
      {
        id: 'bopManage',
        label: '収支管理',
        checked: editPermissionData.canManageBOP,
      },
    ]
  }, [editPermissionData])

  return {
    editPermissionData,
    setEditPermissionData,
    disabled,
    managedWorkspaceCheckBoxItems,
    bopManagementChangeBoxItems,
  }
}
export default useUser
